module.exports = __webpack_public_path__ + "static/media/2-male.b4785dcf.png";